import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { AntimalwareAntiTamperingPanelWebComponentSchema } from '../types';

export class AntimalwareAntiTamperingPanelBaseDataProvider extends BaseWebComponentDataProvider {
  async getDataForView(): Promise<AntimalwareAntiTamperingPanelWebComponentSchema> {
    throw new Error('Not implemented');
  }
}
